import { ReactElement } from 'react';

type AuFlagProps = {
    width?: string;
    height?: string;
};

// eslint-disable-next-line no-empty-pattern
function AuFlag({ width = '40', height = '30' }: AuFlagProps): ReactElement {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 40 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_5541_37128)">
                <g clipPath="url(#clip1_5541_37128)">
                    <path
                        d="M-0.689697 -0.34082H40.6896V30.341H-0.689697V-0.34082Z"
                        fill="#00008B"
                    />
                    <path
                        d="M1.73487 -0.34082L9.6228 5.44398L17.4784 -0.34082H20V1.64071L12.2413 7.3616L20 13.0505V15.0001H17.4137L9.65513 9.27921L1.92884 15.0001H-0.689697V13.0825L7.0366 7.39356L-0.689697 1.70463V-0.34082H1.73487Z"
                        fill="white"
                    />
                    <path
                        d="M13.0172 8.64L20 13.7217V15.0001L11.2392 8.64H13.0172ZM7.06892 9.27921L7.26289 10.3978L1.05599 15.0001H-0.689697L7.06892 9.27921ZM20 -0.34082V-0.24494L11.9504 5.76358L12.015 4.35733L18.3836 -0.34082H20ZM-0.689697 -0.34082L7.0366 5.28418H5.09694L-0.689697 1.00151V-0.34082Z"
                        fill="#FF0000"
                    />
                    <path
                        d="M7.10125 -0.34082V15.0001H12.2737V-0.34082H7.10125ZM-0.689697 4.77282V9.88645H20V4.77282H-0.689697Z"
                        fill="white"
                    />
                    <path
                        d="M-0.689697 5.8275V8.89569H20V5.8275H-0.689697ZM8.13573 -0.34082V15.0001H11.2392V-0.34082H8.13573Z"
                        fill="#FF0000"
                    />
                    <path
                        d="M33.3837 25.0163L32.0582 25.1824L32.2005 26.4928L31.2436 25.5724L30.2931 26.4992L30.4225 25.1888L29.097 25.0354L30.2156 24.3195L29.5108 23.2009L30.7781 23.6164L31.2242 22.3699L31.6832 23.61L32.944 23.1817L32.2522 24.3067L33.3772 25.0163H33.3837ZM33.1444 17.5248L33.319 16.6938L32.6854 16.1185L33.5388 16.0226L33.8944 15.2492L34.25 16.0226L35.1035 16.1185L34.4699 16.6938L34.6444 17.5248L33.8944 17.1029L33.1444 17.5248ZM26.4138 13.6895L25.1013 13.8302L25.2177 15.1278L24.2867 14.2009L23.3298 15.1022L23.485 13.8046L22.1789 13.632L23.2975 12.9417L22.6186 11.8231L23.8664 12.2577L24.3319 11.0368L24.7651 12.2705L26.0194 11.8678L25.3147 12.9736L26.4203 13.6895H26.4138ZM39.5906 11.593L38.2393 11.7655L38.388 13.1015L37.4117 12.1618L36.4419 13.1079L36.5776 11.7655L35.2263 11.6121L36.3707 10.877L35.6531 9.73287L36.9462 10.1611L37.3987 8.89551L37.8643 10.1611L39.1509 9.72008L38.4397 10.8707L39.5906 11.593ZM33.3772 6.25559L32.0388 6.40261L32.1617 7.73216L31.2112 6.78613L30.235 7.70659L30.3901 6.38343L29.0518 6.20446L30.1962 5.50133L29.5044 4.35716L30.7781 4.79821L31.25 3.55176L31.6897 4.81099L32.9699 4.39551L32.2522 5.52051L33.3772 6.25559ZM14.4397 24.3131L11.4785 24.6583L11.7759 27.5922L9.65521 25.5212L7.52159 27.5795L7.8384 24.6455L4.8772 24.2748L7.39228 22.6895L5.84056 20.1711L8.65953 21.1299L9.68108 18.3557L10.6832 21.1363L13.5087 20.1966L11.9375 22.7023L14.4462 24.3067L14.4397 24.3131Z"
                        fill="white"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_5541_37128">
                    <rect width="40" height="30" rx="4" fill="white" />
                </clipPath>
                <clipPath id="clip1_5541_37128">
                    <rect
                        width="41.3793"
                        height="30.6818"
                        fill="white"
                        transform="translate(-0.689697 -0.34082)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export default AuFlag;
